import React from 'react';
import DynamicEditForm from '../../components/DynamicEditForm/DynamicEditForm.js'; // Import your form component
import {getStoredData} from "../../JsonFiles/fetchData";

const EditBlogPage = () => {
  const fields = getStoredData()?.["11"]?.AdminBlog?? {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/blog'; // API URL for fetching/editing product
  const successRedirect = '/admin/blog'; // Where to redirect after a successful update
  
  return (
    <div>
      <DynamicEditForm
        fields={fields}
        apiUrl={apiUrl}
        successRedirect={successRedirect}
      />
    </div>
  );
};

export default EditBlogPage